import * as ACTIONS from '../../actionTypes/priceMatrixActionTypes';

const initialState = null;

function searchInformation(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.INIT_SUCCESS:
      return action.searchInformation;
    default:
      return state;
  }
}

export default searchInformation;
